import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  constructor() { }

  public getYar(): number {
    const date = new Date();
    return date.getFullYear();
  }

  public goToMettadigital() {
    window.open('https://api.whatsapp.com/send/?phone=5511967217258&text=Olá%2C+gostaria+de+saber+mais+sobre+a+lista+de+chá+de+cozinha...', '_blank');
  }
}
